// extracted by mini-css-extract-plugin
export default {"hintContainer":"Tips_hintContainer__IeDyS","tipsIcon":"Tips_tipsIcon__0nUlx"};